// All variables for each axis

const VARIABLES = [
	{
		id: "demanda",
		title: "DEMANDA",
		variables: [
			{
				id: "Poblacion",
				content: "Población total",
				description: "Número de habitantes de un país",
				units: "millones de habitantes",
			},
			{
				id: "Poblacion-0-14",
				content: "Población entre 0 y 14 años",
				description: "Número de habitantes con edad entre 0 y 14 años",
				units: "millones de habitantes",
			},
			{
				id: "Poblacion-15-64",
				content: "Población entre 15 y 64 años",
				description: "Número de habitantes con edad entre 15 y 64 años",
				units: "millones de habitantes",
			},
			{
				id: "Poblacion-65",
				content: "Población mayor de 64 años",
				description: "Número de habitantes con más de 64 años de edad",
				units: "millones de habitantes",
			},
			{
				content: "Gastos eCommerce por categoría",
				description: "Consumo de productos de (nombre de la categoría, p. ej: moda y belleza) a través de internet",
				units: "millones de USD",
				options: [
					{id: "Viajes", content: "Viajes"},
					{id: "Moda", content: "Moda y belleza"},
					{id: "Tecnologia", content: "Tecnología"},
					{id: "Alimentos", content: "Alimentos y cuidado personal"},
					{id: "Muebles", content: "Muebles y electrodomésticos"},
				],
			},
			{
				content: "Importaciones por categoría",
				description: "Bienes adquiridos por un país en el exterior",
				units: "millones de USD",
				options: [
					{id: "Importaciones-alimentos", content: "Alimentos procesados"},
					{id: "Importaciones-aseo", content: "Aseo personal"},
					{id: "Importaciones-hogar", content: "Hogar"},
					{id: "Importaciones-cuero", content: "Artículos de cuero y calzado"},
					{id: "Importaciones-moda", content: "Moda"},
					{id: "Importaciones-mascotas", content: "Mascotas"},
					{id: "Importaciones-tecnologia", content: "Tecnología"},
				],
			},
			{
				content: "Variación en importaciones",
				description: "Cambio en la compra de bienes adquiridos por un país en el exterior",
				units: "%",
				options: [
					{id: "Importaciones-var-alimentos", content: "Alimentos procesados"},
					{id: "Importaciones-var-aseo", content: "Aseo personal"},
					{id: "Importaciones-var-hogar", content: "Hogar"},
					{id: "Importaciones-var-cuero", content: "Artículos de cuero y calzado"},
					{id: "Importaciones-var-moda", content: "Moda"},
					{id: "Importaciones-var-mascotas", content: "Mascotas"},
					{id: "Importaciones-var-tecnologia", content: "Tecnología"},
				],
			},
		],
	},
	{
		id: "idioma",
		title: "IDIOMA",
		variables: [
			{
				id: "Español",
				content: "Español",
				description: "Países cuyo idioma oficial es el español",
			},
			{
				id: "Ingles",
				content: "Inglés",
				description: "Países cuyo idioma oficial es el inglés",
			},
			{
				id: "Otros-idiomas",
				content: "Otros",
			},
		],
	},
	{
		id: "est_mercados",
		title: "ESTABILIDAD DE MERCADOS",
		variables: [
			{
				id: "PIB",
				content: "PIB per cápita",
				description: "Ingreso promedio por habitante en un país determinado",
				units: "USD",
			},
			{
				id: "PIB-increse",
				content: "Crecimiento económico",
				description: "Aumento de la producción de bienes y servicios producidos en un país durante un año",
				units: "%",
			},
			{
				id: "Inflacion",
				content: "Inflación",
				description: "Aumento generalizado y sostenido de los bienes y servicios durante un tiempo determinado",
				units: "%",
			},
		],
	},
	{
		id: "ecommerce",
		title: "ECOMMERCE",
		variables: [
			{
				id: "Internet",
				content: "Personas que usan internet",
				description: "Porcentaje de la población que accede a internet",
				units: "% (de la población)",
			},
			{
				id: "Telefonia",
				content: "Suscripciones a telefonía celular móvil",
				description: "Número de líneas de telefonía celular",
				units: "millones",
			},
			{
				id: "Redes",
				content: "Usuarios activos en redes sociales",
				description: "Porcentaje de la población que está activa en las redes sociales",
				units: "% (de la población)",
			},
			{
				id: "B2C",
				content: "B2C eCommerce Index (UNCTAD)",
				description: "Indicador que mide la preparación de un país para soportar el comercio electrónico",
			},
			{
				id: "Ints-Financiara",
				content: "Población con cuenta en institución financiera",
				description: "Población bancarizada",
				units: "% (de la población)",
			},
			{
				id: "Click",
				content: "Costo por click (USD)",
				description: "El pago que debe realizar un usuario por cada click en sus anuncios",
			},
		],
	},
	{
		id: "acceso",
		title: "ACCESO",
		variables: [
			{
				id: "Minimis",
				content: "De minimis",
				description: "Monto por el cual el país de destino no cobra tributos aduaneros",
				units: "USD",
			},
		],
	},
];

// Mapping of variables and their text

let VARIABLES_CONTENT = {};
for (let i = 0; i < VARIABLES.length; i++) {
	VARIABLES[i].variables.forEach((variable) => {
		if (variable.id !== undefined) {
			VARIABLES_CONTENT[variable.id] = {content: variable.content, units: variable.units ? variable.units : ""};
		} else {
			if (variable.options !== undefined && variable.options.length > 0) {
				variable.options.forEach((option) => {
					VARIABLES_CONTENT[option.id] = {content: option.content, units: variable.units ? variable.units : ""};
				});
			}
		}
	});
}

export {VARIABLES, VARIABLES_CONTENT};
